import React from 'react';
import './Home.css';  // Create a separate CSS file for Home component styles

const Home = () => {
  // Function to handle the scroll behavior when the button is clicked
  const scrollToExpertise = () => {
    document.getElementById("expertise").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="home-section">
      {/* Top-right corner text */}
      {/* <div className="top-right-text">Stella Craig</div> */}
      
      <div className="home-content">
        <h1 className="home-title">Stella Craig</h1>
        <p className="home-description">Software Engineer, Web Developer, and Game Developer</p>
        <button className="scroll-button" onClick={scrollToExpertise}>↓</button>
      </div>
    </section>
  );
};

export default Home;
